module.exports = __webpack_public_path__ + "static/media/nus_logo_plain.381833ba.jpg";